/* eslint-disable */
import { THEME_PALETTE_TYPE_DARK } from '../../../Constants/Theme/Theme.constants';
import throwParameterRequiredError from '../../../Errors/General/ParameterRequired.error';

/**
 * Determine if a given `type` is a `dark`
 * @export
 * @param {any} type The `type` to check
 * @returns {boolean} Whether or not `type` is indeed `dark`
 */
const themeIsDark = (type = throwParameterRequiredError(`type`)) => type === THEME_PALETTE_TYPE_DARK;

export default themeIsDark;
